import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  premiumCareList: [],
  isLoading: true,
  exportPremiumCare: [],
  isExportLoading: false,
};

const premiumCareSlice = createSlice({
  name: 'PremiumCare',
  initialState,
  reducers: {
    setPremiumCareList(state, actions) {
      state.premiumCareList = actions.payload;
      state.isLoading = false;
    },
    setLoading(state, actions) {
      state.isLoading = actions.payload;
    },
    setExportPremiumCare(state, actions) {
      state.exportPremiumCare = actions.payload;
      state.isExportLoading = false;
    },
    setExportLoading(state, actions) {
      state.isExportLoading = actions.payload;
    },
  },
});

export const { setPremiumCareList, setLoading, setExportPremiumCare, setExportLoading } = premiumCareSlice.actions;

const premiumCareReducer = premiumCareSlice.reducer;

export default premiumCareReducer;
